import type { TourId } from './tourIds'
import { TOUR_SESSION_KEY } from './tourIds'

export interface TourSession {
  tourId: TourId
  stepIndex: number
}

export function readTourSession(): TourSession | null {
  try {
    const raw = sessionStorage.getItem(TOUR_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as TourSession
  } catch {
    return null
  }
}

export function writeTourSession(session: TourSession | null): void {
  try {
    if (!session) {
      sessionStorage.removeItem(TOUR_SESSION_KEY)
      return
    }
    sessionStorage.setItem(TOUR_SESSION_KEY, JSON.stringify(session))
  } catch {
    /* ignore */
  }
}
